import { TabPanel } from "devextreme-react"
import { Item as TabPanelItem } from "devextreme-react/tab-panel"
import React from "react"
import { FaCogs } from "react-icons/fa"

import { hasAccessTo } from "../../../authentication"
import { PageTitle, TabItemW } from "../../shared/StyledComponents"
import { getFirstAccessibleIndex } from "../../shared/utilities"
import Database from "./Database"
import Users from "./Users"
import SEO from "../../../seo"
import { faDatabase, faUsersCog } from "../../shared/icons"

const Home = () => {
  return (
    <>
      <SEO title="Core Shopify" />
      <PageTitle icon={FaCogs}>Shopify</PageTitle>
      <TabPanel
        defaultSelectedIndex={getFirstAccessibleIndex([
          "c.shopify.user.r",
          "c.shopify.migrate",
        ])}
      >
        <TabPanelItem
          icon={faUsersCog}
          title="Users"
          visible={hasAccessTo("c.shopify.user.r")}
        >
          <Users />
        </TabPanelItem>
        <TabPanelItem
          icon={faDatabase}
          title="Database"
          visible={hasAccessTo("c.shopify.migrate")}
        >
          <TabItemW>
            <Database />
          </TabItemW>
        </TabPanelItem>
      </TabPanel>
    </>
  )
}

export { Home }
export default Home
